<!--
    @不参与审核的领导首页-日程管理-项目
-->
<template>
	<div class="leader_sch">
		<div class="item" :class="addStatusClass(data.emergencyLevel)">
			<div class="index">{{index+1}}</div>
			<div class="sch_data">
				<div class="sch_title" :title="data.title">{{data.title}}</div>
				<div :title="data.startTime+'到'+data.endTime +'地点'+data.location">
					<span class="sch_time">{{data.startTime|timeTransform(1)}}到{{data.endTime|timeTransform(1)}}</span>
					<span class="sch_address">{{data.location}}</span>
				</div>
			</div>
			<div class="btns">
				<el-button type="text" size="mini" @click.stop="schHandle(1,data.id)">完成</el-button>&nbsp;|&nbsp;
				<el-button type="text" size="mini" @click.stop="schHandle(2,data.id)">删除</el-button>
				<i class="el-icon-top" @click.stop="schMove(1,data.id)"></i>
				<i class="el-icon-bottom" @click.stop="schMove(2,data.id)"></i>
			</div>
		</div>
	</div>
</template>

<script>
import {apiwbschedulemanagementupdateCompleteStatus,apiwbschedulemanagementdelete,apiwbschedulemanagementmove} from '@/server/common';
export default {
	props:{
		index:{
			type:Number,
			default:0
		},
		data:{
			type:Object,
			default:function(){
				return {};
			}
		}
	},
	data(){
		return{}
	},
	methods:{
		schHandle(type,id){
			let tempTypeList={
				1:'完成',
				2:'删除'
			};
			this.$confirm(`是否${tempTypeList[type]}该条数据？`,'提示',{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(()=>{
				type==1&&apiwbschedulemanagementupdateCompleteStatus(id).then((res)=>{
					const {data} = res;
					if(data.code=='1'){
						this.$message({
							type:'success',
							message:'完成成功'
						})
						this.emitEvent();
					}else{
						this.$message({
							type:'error',
							message:data.msg
						})
					}
				})
				type==2&&apiwbschedulemanagementdelete(id).then((res)=>{
					const {data} = res;
					if(data.code=='1'){
						this.$message({
							type:'success',
							message:'删除成功'
						})
						this.emitEvent();
					}else{
						this.$message({
							type:'error',
							message:data.msg
						})
					}
				})
			}).catch(()=>{})
		},
		schMove(type,id){
			apiwbschedulemanagementmove({id,type}).then((res)=>{
				const {data} = res;
				if (data.code=='1') {
					this.emitEvent();
				}else{
					this.$message.error(data.msg);
				}
			})
		},
		emitEvent(){
			this.$emit('emitevent')
		},
		addStatusClass(emergencyLevel){
			let temp={
				1:null,
				2:'zhongyao',
				3:'jinji'
			}
			return temp[emergencyLevel]
		}
	}
}
</script>

<style lang="less" scoped>
.leader_sch{
	.item{
		position: relative;
		display: flex;
		align-items: center;
		padding: 16px 0;
		.index{
			width: 50px;
			text-align: center;
		}
		.sch_data{
			width: calc(100% - 160px);
			>div:nth-child(2){
				width: 100%;
				max-width: 210px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.sch_title{
				width: 85%;
				// max-width: 210px;
				font-weight: bold;
				font-size: 14px;
				margin-bottom: 23px;
				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
			.sch_time{
				margin-right: 10px;
				color: rgba(153, 153, 153, 1);
			}
			.sch_address{
				color: rgba(153, 153, 153, 1);
			}
		}
		.btns{
			width: 100px;
			display: flex;
			align-items: center;
			color: #C7D6EB;
			/deep/ .el-button{
				padding: 5px 0;
			}
			.el-button+.el-button{
				margin-left: 0;
			}
			i{
				cursor: pointer;
			}
		}
		&:after{
			content: '';
			width: 100%;
			height: 1px;
			background: #ebeef5;
			position: absolute;
			bottom: 0;
			left: 0;
		}
	}
	.jinji{
		background: url('../../../../assets/images/home/icon-jinji.png') no-repeat;
		background-size: 45px 45px;
	}
	.zhongyao{
		background: url('../../../../assets/images/home/icon-zhongyao.png') no-repeat;
		background-size: 45px 45px;
	}
}
</style>
